import { useRef } from "react";
import { Camera, X } from "@phosphor-icons/react";

const MAX = 6;

export function shrink(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const im = new Image();
    im.onload = () => {
      const k = Math.min(1, 1600 / Math.max(im.width, im.height));
      const c = document.createElement("canvas");
      c.width = Math.round(im.width * k); c.height = Math.round(im.height * k);
      c.getContext("2d").drawImage(im, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      c.toBlob((b) => resolve(b ? new File([b], "photo.jpg", { type: "image/jpeg" }) : file), "image/jpeg", 0.82);
    };
    im.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    im.src = url;
  });
}

export function HkPhotos({ photos, setPhotos }) {
  const input = useRef();
  const add = async (e) => {
    const files = [...e.target.files].slice(0, MAX - photos.length);
    e.target.value = "";
    const out = await Promise.all(files.map(shrink));
    setPhotos((p) => [...p, ...out.map((f) => ({ file: f, url: URL.createObjectURL(f) }))].slice(0, MAX));
  };
  const drop = (i) => setPhotos((p) => { URL.revokeObjectURL(p[i].url); return p.filter((_, j) => j !== i); });
  return (
    <section className="rounded-3xl bg-white p-5" data-testid="hk-photos-section">
      <div className="flex items-center justify-between"><p className="font-display text-lg">Photos</p><span className="text-sm text-muted-foreground" data-testid="hk-photos-count">{photos.length}/{MAX}</span></div>
      <p className="mt-1 text-sm text-muted-foreground">Show the finished rooms or anything that needs fixing.</p>
      <div className="mt-3 grid grid-cols-3 gap-2">
        {photos.map((p, i) => (
          <div key={p.url} className="relative aspect-square overflow-hidden rounded-xl" data-testid={`hk-photo-${i}`}>
            <img src={p.url} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => drop(i)} data-testid={`hk-photo-remove-${i}`} className="absolute right-1 top-1 grid h-7 w-7 place-items-center rounded-full bg-black/60 text-white"><X size={14} weight="bold" /></button>
          </div>
        ))}
        {photos.length < MAX && (
          <button type="button" onClick={() => input.current.click()} data-testid="hk-add-photo-button" className="flex aspect-square flex-col items-center justify-center gap-1 rounded-xl border-2 border-dashed border-[#C9D3CD] text-xs font-semibold text-[#2F6B4F]">
            <Camera size={24} /> Add photo
          </button>
        )}
      </div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" multiple hidden onChange={add} data-testid="hk-photo-input" />
    </section>
  );
}
